module.exports = __webpack_public_path__ + "img/not-fount.d88922e5.svg";